import React, { useContext, useState, useEffect } from "react";
import uuid from "react-native-uuid";
import "./Form.css";
import ToolComponent from "../ToolComponent/ToolComponent";
import DropDownListNew from "../DropDownList/DropDownListNew";
import useSize from "../../Hooks/useSize.js";
import useUpdateSizeValues from "../../Hooks/useUpdateSizeValues.js";
import useGetCurrentsTools from "../../Hooks/useGetCurrentsTools.js";
import useUpdateGlobalPosition from "../../Hooks/useUpdateGlobalPosition.js";
import useDeleteSourceOccurence from "../../Hooks/useDeleteSourceOccurence";
import useChangeMode from "../../Hooks/useChangeMode.js";
import useUpdateOccurenceValue from "../../Hooks/useUpdateOccurenceValue.js";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import AddCommand from "../Commands/AddCommand/AddCommand";
import SaveCommand from "../Commands/SaveCommand/SaveCommand";
import ValidationCommand from "../Commands/ValidationCommand/ValidationCommand";
import MiddleEditCommand from "../Commands/MiddleEditCommand/MiddleEditCommand";
import CheckBox from "../Commands/CheckBox/CheckBox";
import { store } from "../../store.js";
import ReactDOM from 'react-dom';
import useValidationInput from "../../Hooks/useValidationInput.js";
//import useBuildDataAndTree from "../../Hooks/useBuildDataAndTree";
import ToolTip from "../ToolTip/ToolTip";
import useKeyPress from "../../Hooks/useKeyPress";
import useBuildStyle from "../../Hooks/useBuildStyle";
import useApiOperation from "../../Hooks/useApiOperation.js";
import useGetResponseData from "../../Hooks/useGetResponseData.js";
import useExecuteAction from "../../Hooks/useExecuteAction.js";
import useHandleOnDrop from "../../Hooks/useHandleOnDrop.js";
import useValidationForm from "../../Hooks/useValidationForm.js";

export default function Form(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const deleteSourceOccurence = useDeleteSourceOccurence();
  const executeAction = useExecuteAction();
  const callApi = useApiOperation(globalState.state.formData.lists.validations.events.api.options);
  const getResponseData = useGetResponseData();
  const onHandleDrop = useHandleOnDrop();
  const buildStyle = useBuildStyle();
  const VersionAddId = "VersionAddId";
  const MediaAddId = "MediaAddId";
  const LanguageAddId = "LanguageAddId";
  const FormDelId = "FormDelId";
  const formContainerId = "formContainer"
  const firstCurrentTool = globalState.state.formData.currentTool[0];
  const currentToolIds = globalState.state.formData.currentTool.map(item=> item.id);
  const currentToolGlobalIds = globalState.state.formData.currentTool.map(item=> item.globalId);
  const validationForm = useValidationForm();
  
  const changeMode = useChangeMode();
  const updateValue = useUpdateOccurenceValue();
  //const buildDataAndTree = useBuildDataAndTree();
  const LeftPressed = useKeyPress(37);
  const TopPressed = useKeyPress(38);
  const RightPressed = useKeyPress(39);
  const BottomPressed = useKeyPress(40);
  const PreviousPressed = useKeyPress(90);
  const NextPressed = useKeyPress(89);
  const formId = 1
  //const [isClickContextMenu, setIsClickContextMenu] = useState(false);
  
  const currentMetaData = globalState.state.formData.metasData.filter(menu => menu.id == globalState.state.formData.currentMetaData.id)[0]
    

  const [position, setPosition] = useState({ 
      left: 0
    , top: 0
    , isClickContextMenu:false 
    , isSealed : currentMetaData.isSealed
    , formX :0 , formY:0
    , version : {isClick:false, left: 0, top: 0, operation : "", item:currentMetaData.version }
    , media : {isClick:false, left: 0, top: 0, operation : "", item :currentMetaData.media }
    , language : {isClick:false, left: 0, top: 0, operation : "", item :currentMetaData.language }
    , form : {isClick:false, operation : "" }
    , grid : {show:false, top:10, left : 20}
    , current : {}
  });

  const menuMedias = globalState.state.formData.metasData
  .filter(metaData => metaData.version.value == position.version.item.value
     && metaData.language.id == position.language.item.id)
  .map(metaData => { return {id : metaData.id, item: metaData.media.type + " " + metaData.media.value, media:metaData.media }})

  const menuVersions = globalState.state.formData.metasData
  .filter(metaData => metaData.language.id == position.language.item.id
     && metaData.media.type == position.media.item.type && metaData.media.value == position.media.item.value)
  .map(metaData => { return {id : metaData.id, item: metaData.version.value, version:metaData.version }})

  const menuLanguages = globalState.state.formData.metasData
  .filter(metaData => metaData.media.type == position.media.item.type && metaData.media.value == position.media.item.value
    && metaData.version.value == position.version.item.value)
  .map(metaData => { return {id : metaData.id, item: metaData.language.value, language:metaData.language }})

  const contextMenus = [{ id: 1, type:"HORIZONTAL", item:"Horizontal Alignment" }, { id: 2, type:"VERTICAL", item:"Vertical Alignment" }, { id: 3, type:"DELETE", item:"Delete" }]
  const parentId = globalState.state.formData.metaData[0].id;
  const parentGlobalId = globalState.state.formData.metaData[0].globalId;
  const formTemplate = globalState.state.formData.metaData.filter((item) => item.id === parentId)[0];
  const [actualWidth, actualHeight] = useSize(formTemplate.styles.width.value, formTemplate.styles.height.value, formContainerId);
  const updateSizeValues = useUpdateSizeValues();
  const updateGlobalPosition = useUpdateGlobalPosition();
  const isInputValid = useValidationInput();
  const getCurrentsTools = useGetCurrentsTools();
  
  const loadFormData = () => {
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    const formData = updatedFormData.metaData[0]
    
    executeAction(updatedFormData, firstCurrentTool, globalState.state.formData.actions.event.type.onLoad, props.isExecutionMode)
    
    /*
    if (formData.properties.actions.option == globalState.state.formData.actions.option.api) {
      const currentApi = formData.properties.actions.api.values.values.filter(item => item.id == formData.properties.actions.api.values.id)[0]
      
      const responsePromise = callApi(currentApi)
      responsePromise.then(response => {
        //const data = getResponseData(response, currentApi.id)
        if (updatedFormData.apiData)
          updatedFormData.apiData.push({globalId:currentApi.Schemas.Content.globalId, id:currentApi.id,  data:response})
        else 
          updatedFormData.apiData = [{globalId:currentApi.Schemas.Content.globalId, id:currentApi.id,  data:response}]
        
        if (!updatedFormData.metaData[0].globalId) updatedFormData.metaData[0].globalId = uuid.v4()
        dispatch({
          type: "UPDATE_FORM_WITOUT_HISTORIQUE",
          payload: updatedFormData,
        });
      })
    } else  if (!updatedFormData.metaData[0].globalId) {
        updatedFormData.metaData[0].globalId = uuid.v4()
        dispatch({
          type: "UPDATE_FORM_WITOUT_HISTORIQUE",
          payload: updatedFormData,
        });
    }
    */
  };
  
  useEffect(() => {
    updateSize(formTemplate.id, actualWidth, actualHeight);
    //globalState.state.formData.isEditTool && updateSize(formTemplate.id, actualWidth, actualHeight);
       
  }, [actualWidth,actualHeight]); //onLoad

  
  useEffect(() => {
    //globalState.state.formData.isEditTool && updateSize(formTemplate.id, actualWidth, actualHeight);
    if(globalState.state.formData.metaData[0].properties.actualize.value)
    loadFormData()
    
  }, [globalState.state.formData.metaData[0].properties.actualize.value]); //onLoad
  
  
  const updateSize = (id, width, height) => {
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    if (!updatedFormData.metaData[0].globalId) {
      updatedFormData.metaData[0].globalId = uuid.v4()
           
    }
    updateSizeValues(updatedFormData, id, width, height);
    setCurrentTools(updatedFormData);
    /*
    var currentsTools = [];
    getCurrentsTools(updatedFormData, currentsTools, currentToolIds);
    updatedFormData.currentTool = currentsTools;*/
    
    
    dispatch({
      type: "UPDATE_FORM_WITOUT_HISTORIQUE",
      payload: updatedFormData,
    });
  };
  
  useEffect(() => {
    if (PreviousPressed.keyPressed && !globalState.state.formData.isEditTool) {
      setHistorique(-1); 
    }
  }, [PreviousPressed.keyPressed]);

  useEffect(() => {
    if (NextPressed.keyPressed && !globalState.state.formData.isEditTool) {
      setHistorique(1);
    }
  }, [NextPressed.keyPressed]);

  const setHistorique = (position) => {
    if (props.isExecutionMode) return
    var updatedFormData = globalState.state.historiques.values[globalState.state.historiques.current + position];
    
    if (updatedFormData) {
      updatedFormData.isEditTool = false;
      dispatch({
        type: position == 1 ? "NEXT_FORM" : "PREV_FORM",
        payload: JSON.parse(JSON.stringify(updatedFormData)),
      });
    }
  };

  useEffect(() => {
    if (LeftPressed.keyPressed && !globalState.state.formData.isEditTool) {
      moveControl('left', -1);
    }
  }, [LeftPressed.keyPressed]);

  useEffect(() => {
    if (TopPressed.keyPressed && !globalState.state.formData.isEditTool) {
      moveControl('top', -1);
    }
  }, [TopPressed.keyPressed]);

  useEffect(() => {
    if (RightPressed.keyPressed && !globalState.state.formData.isEditTool) {
      moveControl('left', 1);
    }
  }, [RightPressed.keyPressed]);

  useEffect(() => {
    if (BottomPressed.keyPressed && !globalState.state.formData.isEditTool) {
      moveControl('top', 1);
    }
  }, [BottomPressed.keyPressed]);

  const moveControl = (type, shiftValue) => {
    if (props.isExecutionMode) return
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    
    var currentToolIdsWithOutForm = currentToolIds.filter(id=> id != parentId)
    updateShiftPositionValue(updatedFormData, currentToolIdsWithOutForm, type, shiftValue);
    setCurrentTools(updatedFormData);
   
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
    
  }

  const setCurrentTools = (updatedFormData) => {
    var currentsTools = [];
    getCurrentsTools(updatedFormData, currentsTools, currentToolIds);
    updatedFormData.currentTool = currentsTools;
  }
  const updateShiftPositionValue = (containers, currentToolIdsWithOutForm, type, shiftValue) => {
    if (!containers.metaData) return;
    containers.metaData.map(item => {
      if (currentToolIdsWithOutForm.includes(item.id)  && containers.type !== "DataGrid" 
      && containers.type !== "TabPanel" && containers.type !== "ListView" 
      && containers.type !== "SplitListView"
      ) {
        if (containers.id == parentId) {
          //let formPosition = position[type] - formValue;
          let formPosition = item.styles[type].value + shiftValue;
          if (formPosition > 0)
            item.styles[type].value = formPosition;
        } else
        {
          //let containerPosition = position[type] - containers[type];
          let containerPosition = item.styles[type].value + shiftValue;
          if (containerPosition > 0)
            item.styles[type].value = containerPosition;
        }
      
      }
      updateShiftPositionValue(item, currentToolIdsWithOutForm, type, shiftValue);
    });
  };

  const onDragStart = (e, template) => {
    
    const currentToolPosition = document.getElementById(template.id).getBoundingClientRect()
    const clickRelativePosition = {left:e.clientX - currentToolPosition.x , 
      top:e.clientY - currentToolPosition.y}
    template["clickRelativePosition"] = clickRelativePosition

    e.dataTransfer.setData("controlId", JSON.stringify(template));
    setPosition({...position, clickRelativePosition: clickRelativePosition})
    e.stopPropagation();
  };

  const getInputToValidate = (value) => {
    var inputValue = {value: value}
    if (firstCurrentTool.properties.decimalSeparator) {
      inputValue["decimalSeparator"] = firstCurrentTool.properties.decimalSeparator.value
      inputValue["wholeNumberLength"] = parseInt(firstCurrentTool.properties.wholeNumberLength.value)
      inputValue["decimalSize"] = parseInt(firstCurrentTool.properties.decimalSize.value)
      inputValue["groupSeparator"] = firstCurrentTool.properties.groupSeparator.value
      inputValue["groupSize"] =parseInt(firstCurrentTool.properties.groupSize.value)
      inputValue["masks"] = firstCurrentTool.properties.masks.value
    };
    return inputValue
  };

  const changeValue = (e, value, event) => {
    
    if(!firstCurrentTool.properties.validations || !firstCurrentTool.properties.validations.selectedValues|| canUpdate(value, event)) {
      
      const type = "properties"
      const menuItem ="text"
      const isProperty = true
      var updatedPosition = JSON.parse(JSON.stringify(position));
      if (updatedPosition.current.errorType) {
        updatedPosition.current.errorType = updatedPosition.current.errorType.filter(item => item.id != firstCurrentTool.id);
        if (updatedPosition.current.errorType.length == 0)
          updatedPosition.current = {}
        setPosition(updatedPosition);
      }
      
      updateValue(value, menuItem, type, isProperty, globalState.state.formData.actions.event.type.onLoad
        , {actualToolGlobalIds:currentToolGlobalIds, actualToolIds:currentToolIds}, undefined, undefined
        , { maskData : firstCurrentTool.properties.masks ? firstCurrentTool.properties.masks.value : "", 
            prefix : firstCurrentTool.properties.prefix ? firstCurrentTool.properties.prefix.value : "",
            suffix : firstCurrentTool.properties.suffix ? firstCurrentTool.properties.suffix.value : "",
            groupSeparator : firstCurrentTool.properties.groupSeparator ? firstCurrentTool.properties.groupSeparator.value : "",
            groupSize : firstCurrentTool.properties.groupSize ? parseInt(firstCurrentTool.properties.groupSize.value) : "",
            caretPosition: e && e.target.selectionStart} );
    }
    else e.preventDefault()
    
  };

  const getCoordinatePosition = (e, container, currentClickRelativePosition = position.clickRelativePosition) => {
    var x = e.clientX + container.scrollLeft ;
    var y = e.clientY + container.scrollTop;
    
    if (currentClickRelativePosition) {
            
      x = x  - (currentClickRelativePosition ? currentClickRelativePosition.left : 0)
      y = y  - (currentClickRelativePosition ? currentClickRelativePosition.top : 0)
    }
      
    x = x - container.getBoundingClientRect().x;
    y = y - container.getBoundingClientRect().y;
    return {x: x, y:y}
  };

  const drop = (e) => {
    if (props.isExecutionMode) return
    e.preventDefault();
    var formContainer = document
      .getElementById(formContainerId);

    var formContainerClientRect = formContainer.getBoundingClientRect();

    var dataTransfer = e.dataTransfer.getData("controlId");
    if (dataTransfer){
      
      var template = JSON.parse(dataTransfer);
      
      /*
      var x = e.clientX + formContainer.scrollLeft ;
      var y = e.clientY + formContainer.scrollTop;
      
      if (template.clickRelativePosition) {
        x = x  - (template.clickRelativePosition ? template.clickRelativePosition.left : 0)
        y = y  - (template.clickRelativePosition ? template.clickRelativePosition.top : 0)
      }
      
      template.styles.left.value = x - formContainerClientRect.x;
      template.styles.top.value = y - formContainerClientRect.y;
      */
      var coordinate = getCoordinatePosition(e, formContainer, template.clickRelativePosition)
      var x = coordinate.x ;
      var y = coordinate.y;
      template.styles.left.value = x;
      template.styles.top.value = y;

      template["parentId"] = [parentId];
      if (template.styles.left.value> 0 && template.styles.top.value>0){
        template["left"] = {value:x};
        template["top"] = {value:y};
       
        //template["scrollX"] = window.scrollX;
        //template["scrollY"] = window.scrollY;
        delete template.clickRelativePosition
        updateGlobalPosition(template);
        var updatedFormData = JSON.parse(
          JSON.stringify(globalState.state.formData)
        );   
        
        handleOnDrop(updatedFormData, 
          {id:[parentId], globalId:[parentGlobalId]}
          //[parentId]
          , template);
      } 
    }
  };
  
  const handleOnDrop = (updatedFormData, currentParentIds, template, schema) => {
    
       
    onHandleDrop(updatedFormData, currentParentIds, template, schema)
    
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
    
    setPosition({...position, grid:{...position.grid, show:false}, clickRelativePosition:undefined});
  };

  /*
  const handleOnDrop = (updatedFormData, currentParentIds, template, schema) => {
    
    //var currentParentId = currentParentIds[0];
    var current = template
    var id = updatedFormData.lists.currentMaxId
    
    if (template.id == 0) {
      id = id + 1;
      var order = updatedFormData.metaData.length + 1;
      //const name = template.properties.name.value
      template.id = id;
      template.order = order;
      template["globalId"] = uuid.v4()
      template["parentId"] = currentParentIds.id;
      template["parentGlobalId"] = currentParentIds.globalId;
     
      template.properties.name.value = template.type + id; //name + id;
      
      if (template.metaData) {
        template.metaData.map(
          (item) => {
              id = id + 1;
              item.id = id;
              item.properties.name.value = item.type + id; //item.properties.name.value + id;
              
              item["globalId"] = uuid.v4()
              item["parentId"] = [template.id, ...currentParentIds.id];
              item["parentGlobalId"] = [template.globalId, ...currentParentIds.globalId] ;
              item["left"] = {value:template.left.value};
              item["top"] = {value:template.top.value};
    
              item.order = template.metaData.length + 1; //a revoir mal calcule
          }
        );
      }
      
      current = template
      if (schema && schema.type == "DataGrid"){
        const value = handleOnDropDataGrid(template, schema, currentParentIds, id)
        id = value[0]
        current = value[1]
      }
      updatedFormData.lists.currentMaxId = id;
    } else {
      
      if (schema && schema.type == "DataGrid"){
        const value =  handleOnDropDataGrid(template, schema, currentParentIds, id)
        updatedFormData.lists.currentMaxId = value[0]
        current = value[1]
        ;
      }
      deleteSourceOccurence(updatedFormData, [template.id] )
    }

    
    
    
    addNewOccurence (updatedFormData,currentParentIds.id[0] , template, schema); 
    
    updatedFormData.currentTool = [current];
   

    buildDataAndTree(updatedFormData)
    
   
    
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
    
    
  };

  const handleOnDropDataGrid = (template, schema, currentParentIds, id) => {
    
      id = id + 1
      var header = JSON.parse(JSON.stringify(template))
      header.id = id
      header.properties.name.value = header.type + id; //name + id;
      header["parentId"] = currentParentIds.id;
      header["parentGlobalId"] = currentParentIds.globalId;
      header["globalId"] = uuid.v4()
      template = header
      var row = JSON.parse(JSON.stringify(template))
      var filter =  JSON.parse(JSON.stringify(template))
      if (replacesType.includes(template.type)) {
        filter = JSON.parse(JSON.stringify(searchTemplate))
        filter.styles.height =  {value: template.styles.height.value}
        filter.styles.width =  {value:template.styles.width.value}
      }
      row["headerId"] = id
      filter["headerId"] = id
      id = id + 1
      row.id = id;
      row.properties.name.value = row.type + id; //name + id;
      row["globalId"] = uuid.v4()
      row["parentId"] = currentParentIds.id;
      row["parentGlobalId"] = currentParentIds.globalId;
      

      id = id + 1
      filter.id = id;
      filter.properties.name.value = filter.type + id; //name + id;
      
      filter["globalId"] = uuid.v4()
      filter["parentId"] = currentParentIds.id;
      filter["parentGlobalId"] = currentParentIds.globalId;

      schema["header"] = header
      schema["rows"] = row
      schema["filter"] = filter
      return [id, header]
  };
 

  const addNewOccurence = (containers,containerId, template, schema) => {
    if (!containers.metaData) return;
    containers.metaData.map(container => {
        if (container.id == containerId){
          if(schema && schema.type == "DataGrid") {
            container.metaData.filter(item => item.type == "Header")
              .map(item => {
                
                schema.header.parentId = [item.id, ...schema.header.parentId]
                schema.header.parentGlobalId = [item.globalId, ...schema.header.parentGlobalId]
                item.metaData.push(schema.header)
              }
            );
            container.metaData.filter(item => item.type == "Filter")
              .map(item => {
                
                schema.filter.parentId = [item.id, ...schema.filter.parentId]
                schema.filter.parentGlobalId = [item.globalId, ...schema.filter.parentGlobalId]
                item.metaData.push(schema.filter)
              }
            );
            container.metaData.filter(item => item.type == "Rows")
              .map(item => {
                
                schema.rows.parentId = [item.id, ...schema.rows.parentId]
                schema.rows.parentGlobalId = [item.globalId, ...schema.rows.parentGlobalId]
                item.metaData.push(schema.rows)
              }
            );
          } else if(schema && schema.type == "Row") {
            let n = container.metaData.length
            
            container.metaData = [...container.metaData.slice(0,schema.index + 1)
              , template
              ,...container.metaData.slice(schema.index + 1,n) ] ;
             
          }
          
          else container.metaData.push(template);
          
          if (container.selectedValues) {
            if(schema && schema.type == "DataGrid") {         
              container.selectedValues.push(schema.header.id);
            }
            else container.selectedValues.push(template.id);
          }
          return;
        }
        else 
          addNewOccurence(container,containerId, template, schema);
      }
    )
  };

  */
 
  var previousCoordinate = {x:0, y:0, countSuccessifCursorStable:0}
  const dragOver = (e) => {
    var template = e.dataTransfer.getData("controlId")
  
    if (props.isExecutionMode) return
    e.preventDefault();
    var updatedPosition = JSON.parse(JSON.stringify(position));
    //e.preventDefault(); 
    //var formContainerRect = document.getElementById(formContainerId).getBoundingClientRect();
    //clickRelativePosition = dataTransfer.clickRelativePosition;
    var coordinate = undefined
    
    if (template  === "") 
      coordinate = getCoordinatePosition(e, document.getElementById(formContainerId)) 
    else
      coordinate = getCoordinatePosition(e, document.getElementById(formContainerId), JSON.parse(template).clickRelativePosition)
    
    
    updatedPosition.grid.left = coordinate.x; //e.clientX + window.scrollX - formContainerRect.x;
    updatedPosition.grid.top = coordinate.y; //e.clientY + window.scrollY - formContainerRect.y;
    //updatedPosition.formX = formContainerRect.x + window.scrollX;
    //updatedPosition.formY = formContainerRect.y + window.scrollY;
    updatedPosition.grid.show = true
    
    const isCursorStable = previousCoordinate.x == coordinate.x && previousCoordinate.y == coordinate.y
    const isSamePreviousPosition = position.grid.left == coordinate.x && position.grid.top == coordinate.y
    
    if (isCursorStable)
      previousCoordinate.countSuccessifCursorStable = previousCoordinate.countSuccessifCursorStable + 1
    else
      previousCoordinate.countSuccessifCursorStable = 0

    if (previousCoordinate.countSuccessifCursorStable == 2 && !isSamePreviousPosition)
      setPosition(updatedPosition)
    else    
      previousCoordinate = {...coordinate, countSuccessifCursorStable:previousCoordinate.countSuccessifCursorStable}
  };

  const getStyle = (meta) => {
    
    var newStyle = buildStyle(meta.styles);
    
   
    var isSelected = currentToolIds.includes(meta.id); 
    //newStyle["minHeight"] = meta.styles.height
    //newStyle["height"] = undefined
    newStyle["border"] = !props.isExecutionMode && isSelected ? "1px dashed gray" : meta.styles.border.value;
    if (props.isExecutionMode) newStyle["resize"] = "none"
    return newStyle;
  };

  const onClick = (e, template) => {
     
    if(!isContextMenuItemClick(e)) {
    
      if (!currentToolIds.includes(template.id)) {
        var updatedFormData = JSON.parse(
        JSON.stringify(globalState.state.formData)
        );

        updatedFormData.currentTool = [template];

        dispatch({
        type: "UPDATE_FORM_WITOUT_HISTORIQUE",
        payload: updatedFormData,
        });
      }
    }
  };
/*
  const onContextMenu = (e) => {
    e.preventDefault(); 

    var formContainer = document
    .getElementById("formContainer")
    .getBoundingClientRect();
    
    var x = e.clientX + window.scrollX;
    var y = e.clientY + window.scrollY;
    
    setPosition({ left: x , top:  y , isClickContextMenu:true, formX:formContainer.x, formY: formContainer.y });
  } 
  */

  const onContextMenu = (e) => {
   
    var updatedPosition = JSON.parse(JSON.stringify(position));
    e.preventDefault(); 
    var formContainerRect = document
    .getElementById(formContainerId)
    .getBoundingClientRect();
    
    
    
    updatedPosition.left = e.clientX + window.scrollX;
    updatedPosition.top = e.clientY + window.scrollY;
    updatedPosition.formX = formContainerRect.x + window.scrollX;
    updatedPosition.formY = formContainerRect.y + window.scrollY;
    updatedPosition.isClickContextMenu = true;
    setPosition(updatedPosition)
  } 

  const deleteCurrentsControls = (currentToolIdsWithOutForm) => {

    if (currentToolIdsWithOutForm.length> 0){

      var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));

      deleteSourceOccurence(updatedFormData, currentToolIdsWithOutForm);
          
      updatedFormData.currentTool[0].styles = [];
      updatedFormData.currentTool[0].properties = [];
           
      dispatch({
        type: "UPDATE_FORM",
        payload: updatedFormData,
      });

    }
    
  }

  const updatePositionValue = (containers, currentToolIdsWithOutForm, type, formValue, positionTypeValue) => {
    if (!containers.metaData) return;
    containers.metaData.map(item => {
      if (currentToolIdsWithOutForm.includes(item.id)  && containers.type !== "DataGrid"
      && containers.type !== "TabPanel" && containers.type !== "ListView" 
      && containers.type !== "SplitListView") {
        if (containers.id == parentId) {
          //let formPosition = position[type] - formValue;
          let formPosition = positionTypeValue - formValue;         
          if (formPosition > 0)
            item.styles[type].value = formPosition;
        } else
        {          
          //let containerPosition = position[type] - containers[type];
          let containerPosition = positionTypeValue - item[type].value; //.value;
           
          if (containerPosition > 0)
            item.styles[type].value = containerPosition;
        }
      
      }
      updatePositionValue(item, currentToolIdsWithOutForm, type, formValue, positionTypeValue);
    });
  };

  const setPositionValue = (updatedFormData, currentToolIdsWithOutForm, type, formValue, positionTypeValue) => {
    
    updatePositionValue(updatedFormData, currentToolIdsWithOutForm, type, formValue, positionTypeValue);
    setCurrentTools(updatedFormData);
    /*
    var currentsTools = [];
    getCurrentsTools(updatedFormData, currentsTools, currentToolIds);
    updatedFormData.currentTool = currentsTools;*/
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
        
  };
  const onRightMenuClick = (item) => {
    
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    
    var currentToolIdsWithOutForm = currentToolIds.filter(id=> id != parentId)
    switch (item.type) {
      case "VERTICAL":{
        setPositionValue(updatedFormData, currentToolIdsWithOutForm , 'left', position.formX, position["left"])
        /*
        updatePositionValue(updatedFormData, currentToolIdsWithOutForm, 'left', position.formX);
        var currentsTools = [];
        getCurrentsTools(updatedFormData, currentsTools, currentToolIds);
        updatedFormData.currentTool = currentsTools;
        dispatch({
          type: "UPDATE_FORM",
          payload: updatedFormData,
        });*/
        break;
      }
      case "HORIZONTAL":{
        setPositionValue(updatedFormData, currentToolIdsWithOutForm , 'top', position.formY, position["top"])
        /*
        updatePositionValue(updatedFormData, currentToolIdsWithOutForm, 'top', position.formY);
        var currentsTools = [];
        getCurrentsTools(updatedFormData, currentsTools, currentToolIds);
        updatedFormData.currentTool = currentsTools;
        dispatch({
          type: "UPDATE_FORM",
          payload: updatedFormData,
        });*/
        break;
      }
      case "DELETE":{
        deleteCurrentsControls(currentToolIdsWithOutForm);
        break;
      }
    }
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition.isClickContextMenu = false;
    setPosition(updatedPosition);
    //setPosition({ left: position.left, top:  position.top, isClickContextMenu:false, formX:position.formX, formY:position.formY });
  } 

  const onMouseDown =(e) => {
    if(!isContextMenuItemClick(e))
      if (position.isClickContextMenu) {
        var updatedPosition = JSON.parse(JSON.stringify(position));
        updatedPosition.isClickContextMenu = false;
        setPosition(updatedPosition);
        //setPosition({ left: position.left, top:  position.top, isClickContextMenu:false, formX:position.formX, formY:position.formY });
        /*setIsClickContextMenu(false);*/
      }
    
  }

  

  const isContextMenuItemClick = (e) => {
    return e.target.className == "liautocomplete";
  }

  const setMenuPositon  = (e, updatedPosition, menu, operation, isClick) => {
    updatedPosition[menu].left = e.clientX + window.scrollX;
    updatedPosition[menu].top = e.clientY + window.scrollY;
    updatedPosition[menu].operation = operation
    
    updatedPosition[menu].isClick = isClick;
  }
  const onClickOperation = (e, type, operation) => {
    e.preventDefault(); 
    var updatedPosition = JSON.parse(JSON.stringify(position));
    setMenuPositon(e, updatedPosition, type, operation, true)
    setPosition(updatedPosition);
  }
 
  const onClickClose = (menu, e = undefined) => {
    if(e) e.preventDefault(); 
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition[menu].isClick = false;
    setPosition(updatedPosition);
  }
  
  const Validation = (menu) => {
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));   
    

    switch (position[menu].operation) {
      case globalState.state.formData.menu.operation.Add:{

        var newData = JSON.parse(JSON.stringify(updatedFormData.metasData
          .filter(metaData => metaData.id == updatedFormData.currentMetaData.id)[0]))

        updatedFormData.currentMetaData.maxId = updatedFormData.currentMetaData.maxId + 1;

        updatedFormData.currentMetaData.id = updatedFormData.currentMetaData.maxId;

        newData[menu] = position[menu].item ;
        newData.id = updatedFormData.currentMetaData.maxId;
        

        updatedFormData.metaData = newData.values;
        updatedFormData.metasData.push(newData)
        
        break;
      }
      case globalState.state.formData.menu.operation.Update:{
        updatedFormData.metasData
        .filter(menu => menu.id == updatedFormData.currentMetaData.id)
        .map(metaData => {
          metaData[menu] = position[menu].item ;
        })
        break;
      }

      case globalState.state.formData.menu.operation.Delete:{
        
        var updatedPosition = JSON.parse(JSON.stringify(position));
        
        updatedFormData.metasData = updatedFormData.metasData
        .filter(menu => menu.id != updatedFormData.currentMetaData.id)

        
        var newData = updatedFormData.metasData[0]

        updatedPosition.version.item = newData.version
        updatedPosition.media.item = newData.media
        updatedPosition.version.item = newData.version
        updatedPosition.form.isClick = false

        updatedFormData.metaData = newData.values
        updatedFormData.currentMetaData.id = newData.id;

        setPosition(updatedPosition)
        break;
      }
    }
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
  }

  const onClickValid = (e, option) => {
      onClickClose(option, e)
      Validation(option)
  }

  const canEdit = () => {
    return globalState.state.formData.currentMetaData.isSealed == false
  }

  const canDelete = () => {
    return canEdit() && globalState.state.formData.metasData.length > 1
  }

  const onSelectNewMetaData = (itemSelected, code) => {
    
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));   
    var updatedPosition = JSON.parse(JSON.stringify(position));
    
    var metaDataSelected = undefined;
    
    switch (code) {
      case globalState.state.formData.menu.type.media:{
        updatedPosition.media.item.type = itemSelected.media.type;
        updatedPosition.media.item.value = itemSelected.media.value;
        
        metaDataSelected =  JSON.parse(JSON.stringify(updatedFormData.metasData
        .filter(metaData => metaData.version.value == position.version.item.value
          && metaData.language.id == position.language.item.id
          && metaData.media.type == itemSelected.media.type && metaData.media.value == itemSelected.media.value)
          [0]));

        break;
      }
      case globalState.state.formData.menu.type.version:{
        updatedPosition.version.item.value = itemSelected.version.value;

        metaDataSelected =  JSON.parse(JSON.stringify(updatedFormData.metasData
        .filter(metaData => metaData.language.id == position.language.item.id
          && metaData.media.type == position.media.item.type && metaData.media.value == position.media.item.value
          && metaData.version.value == itemSelected.version.value)
          [0]));
        break;
      }
      case globalState.state.formData.menu.type.language:{
        updatedPosition.language.item.id = itemSelected.language.id;
        updatedPosition.language.item.value = itemSelected.language.value;

        metaDataSelected =  JSON.parse(JSON.stringify(updatedFormData.metasData
        .filter(metaData => metaData.media.type == position.media.item.type && metaData.media.value == position.media.item.value
          && metaData.version.value == position.version.item.value
          && metaData.language.id == itemSelected.language.id)
          [0]));
        break;
      }
    }
    updatedFormData.metaData = metaDataSelected.values;
    updatedFormData.currentMetaData.id = metaDataSelected.id;
    updatedFormData.currentMetaData.isSealed = metaDataSelected.isSealed;
    updatedPosition.isSealed = metaDataSelected.isSealed;
    setPosition(updatedPosition);
    dispatch({
      type: "UPDATE_FORM_WITOUT_HISTORIQUE",
      payload: updatedFormData,
    });
  }
  

  const onClickDeleteLink = () => {
    /*
    var selectedItem = getSelectedItem(getLinkId(13))
    selectedItem["operation"] = "DEL"
    props.onClickItem(selectedItem)
    closeLinkForm()*/
  }

  const getSeparator = () => {
    return <div style={{  height: "17px", margin:"5px 15px 0px 10px",  borderRight:"2px solid rgb(223, 221, 221)" }} /> 
  }

  const getTitle = (menuType, replaces) => {
    const currentType =  position[menuType].errorType ? position[menuType].errorType : position[menuType].operation
    return globalState.state.formData.log.filter(
      log => log.type == currentType
    ).map( log =>  {return <span style = {log.style}>{replaceValue(log.value, replaces)}</span>})[0]
  }
  const getValidationText = () => {
      
    return globalState.state.formData.log.filter(
      log => log.type == position.current.errorType[0].type
    ).map( log =>  {return log.value
      .replace(globalState.state.formData.actions.replacesValues.field, position.current.errorType[0].field)})
      [0]
  }

  const replaceValue = (value, replaces) => {
    if( replaces )
      replaces.map(replace => value = value.replace(replace.old, replace.new)) 
    return value
  }

  /*
  <div style ={{ marginLeft: "3px", marginTop: "4px" }}>
              <input type="button" style ={{ fontWeight: "20px", height: "25px", padding: "0px 10px" }} 
              className="button" value="Set As Current Version" />
          </div>
  */

  const getTypeEvents = (validationData, event) => {
    return validationData.filter(item => item.events.includes(event))
  }

  const fireEventKeyPressByControl = (e, event) => {
    
    const validationData = firstCurrentTool.properties.validations
    const typeEvents = validationData && validationData.selectedValues ? getTypeEvents(validationData.selectedValues, event) : []
    if(typeEvents.length > 0 && !isInputValid({value: e.key, actualValue:e.target.value
      , decimalSeparator:firstCurrentTool.properties.decimalSeparator.value
      }, typeEvents).isValid) {
      e.preventDefault()
    }
  }

  const canUpdate = (value, event) => {
    const validationData = firstCurrentTool.properties.validations.selectedValues
    const typeEvents = getTypeEvents(validationData, event)
    const inputValue = getInputToValidate(value)
    const eventResponse = isInputValid(inputValue, typeEvents);
    return eventResponse.isValid
  };

  const setErrorType = () => {

    var errors = []
    validationForm(globalState.state.formData, errors, globalState.state.formData.log,
      globalState.state.formData.actions.replacesValues.field)
    //setPosition({...position, current:{errorType: errors}})

    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    updatedFormData.errors = errors
    
    if (errors.length > 0)
      dispatch({
        type: "UPDATE_FORM_WITOUT_HISTORIQUE",
        payload: updatedFormData,
      });
  };
  
  const fireEventByControlAndSetValue = (e, meta, event) => {
    
    
    if (globalState.state.formData.actions.event.type.onBlur == event || (meta.type == "Button" && globalState.state.formData.actions.event.type.onClick == event))
      setErrorType()

    
    const validationData = meta.properties.validations
    const typeEvents = validationData ? getTypeEvents(validationData.selectedValues, event) : []
    
    var updatedPosition = JSON.parse(JSON.stringify(position));
    var isChanged = false
  
    

    if (typeEvents.length > 0) {
      const eventResponse = isInputValid({value: e.target.value}, typeEvents);
      updatedPosition.current["replacesValues"] = validationData.replacesValues ? validationData.replacesValues : []
      if(eventResponse.isValid)
        updatedPosition.current["errorType"] = undefined;
      else {
        if (updatedPosition.current["errorType"])
          updatedPosition.current["errorType"].push({id:meta.id, type:eventResponse.type, field:meta.properties.field.value})
        else
          updatedPosition.current["errorType"] = [{id:meta.id, type:eventResponse.type, field:meta.properties.field.value}];
      }
      isChanged = true
    }
    if (meta.properties.toolTip && meta.properties.toolTip.value) {
      if (event == globalState.state.formData.actions.event.type.onMouseEnter) { //if (event == globalState.state.formData.actions.event.type.onMouseOver) {
        
        const errors = globalState.state.formData.errors.filter(item => item.id == meta.id)[0]
        
        if (errors)
          updatedPosition["toolTip"] = 
          { isError : true,
            text : errors.value
          , show:true
          , styles: getToolStyle(e, errors.styles.width)
          , time:new Date()
        }
        else {
          const text = meta.properties.toolTipText.value != "" ? meta.properties.toolTipText.value :
          (typeof meta.properties.text.value == "object" ? meta.properties.text.value.item : meta.properties.text.value)
          if (text != "") {
            updatedPosition["toolTip"] = 
            { isError : undefined,
               text : text
            , show:true, styles: getToolStyle(e, meta.styles.width.value)
            , time:new Date()}
          }
        }
        isChanged = true
      }
      
      if (event == globalState.state.formData.actions.event.type.onMouseDown) {
          
          if (updatedPosition.toolTip) {
            isChanged = true
            updatedPosition.toolTip = undefined
          }
      }

      if (event == globalState.state.formData.actions.event.type.onMouseLeave ) {
        
        //if (updatedPosition.toolTip) console.log(new Date(updatedPosition.toolTip.time))
        if (updatedPosition.toolTip && ((new Date().getSeconds() - new Date(updatedPosition.toolTip.time).getSeconds()) != 0)) {
          isChanged = true
          updatedPosition.toolTip = undefined
        }
       
    }
    } else {
      if (updatedPosition.toolTip) isChanged = true
      updatedPosition.toolTip = undefined
    }
    e.stopPropagation()
   
    if (isChanged) setPosition(updatedPosition);
   
  }

  const fireEventKeyPressByMenu = (e, menuType, event) => {
    const typeEvents = globalState.state.formData.menu[menuType].validations[event]
    if(!isInputValid({value: e.key}, typeEvents).isValid) {
      e.preventDefault()
    }
  }

  const fireEventByMenuAndSetValue = (e, menuType, event) => {
    
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition[menuType].item.value = e.target.value;
    const typeEvents = globalState.state.formData.menu[menuType].validations[event]
    const eventResponse = isInputValid({value: e.target.value}, typeEvents);
    if(eventResponse.isValid)
      updatedPosition[menuType]["errorType"] = undefined;
    else
      updatedPosition[menuType]["errorType"] = eventResponse.type;
    
    setPosition(updatedPosition);
  }

  const onSelectLanguage = (itemSelected) => {
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition.language.item.id = itemSelected.id;
    updatedPosition.language.item.value = itemSelected.item;
    setPosition(updatedPosition);
  }

  const onSelectMediaType = (itemSelected) => {
    
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition.media.item.type = itemSelected.item;
    
    setPosition(updatedPosition);
  }

  /*const onKeyPressMedia = (e) => {
    
    const typeValidation = "NUMBER";
    const input = inputValidation(typeValidation, e.key)
    
    if(!input.isValid) {
      e.preventDefault()
    }
  }*/

  const getErrorStyle = (styles) => {
    //var currentStyle = JSON.parse(JSON.stringify(globalState.state.formData.currentTool[0].styles));
    
    //return {top:styles.top , left:styles.left,position:"absolute" , width:"100%" };
    return {top:styles.top.value , left:styles.left.value,position:"absolute" , width:styles.width.value, zIndex:"10000" };
  };
  
  const getErrorComponent = () => {
    
    const error = globalState.state.formData.metaData
    .filter(menu => menu.id == formId)[0].metaData
    .filter(item => item.properties.eventInfo && item.properties.eventInfo.value == true)[0]
    return (   error ?
        ReactDOM.createPortal(
        <div style={getErrorStyle(error.styles)}>
          <ToolTip
            canShowToolTip={true}
            isError = {true}
            text={getValidationText()}
          />
        </div>, document.getElementById(formContainerId) 
      ) : null
    ) ;
  };
  
  const showToolTip = () => {
    
    return (
        ReactDOM.createPortal(
        <div style={{...position.toolTip.styles, zIndex:"10000"}}>
          <ToolTip
            canShowToolTip={position.toolTip.show}
            text={position.toolTip.text}
            isError={position.toolTip.isError}
            width={position.toolTip.width}/>
        </div>, document.body //document.getElementById(formContainerId)
      ) 
    );
  };
  
  const getToolStyle = (e, width) => {    
    //var newStyle = {top:meta.styles.top.value + height, left:meta.styles.left.value, position: "absolute", width:meta.styles.width.value};
    var newStyle = {top:e.clientY + window.scrollY
      , left:e.clientX + window.scrollX
      , position: "absolute"
      
      
      
      , width:width};

   
    return newStyle;
  };

  const showGrid = () => {    
   
    
    return (
      ReactDOM.createPortal(
      <React.Fragment>
        <div style ={{position:"absolute", zIndex:10000, top: 0, left:position.grid.left, height: "100%", backgroundColor: "#008dff", width: "1px", boxSizing:"border-box"}} />
        <div style ={{position:"absolute", zIndex:10000, top: position.grid.top, left:0, height: "1px", backgroundColor: "#008dff", width: "100%", boxSizing:"border-box"}} />
      </React.Fragment>
  
      ,
       document.getElementById(formContainerId)
    ) 
  );
  };

  /*
  const getToolStyle = (meta) => {
    const height = parseInt(meta.styles.height.value.slice(0, -2))
    
    //var newStyle = {top:meta.styles.top.value + height, left:meta.styles.left.value, position: "absolute", width:meta.styles.width.value};
    var newStyle = {top:meta.styles.top.value + height
      , left:meta.styles.left.value
      , position: "absolute"
      , width:meta.styles.width.value};

   
    return newStyle;
  };*/

  const getVersionComponent = () => {
    return (
        ReactDOM.createPortal(
        <div className="dialogForm" style ={{   height: "60px", width: "210px" }}>
          <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              { getTitle(globalState.state.formData.menu.type.version, globalState.state.formData.menu.version.replacesValues) }
            </div>
            
            <div onClick={(e) => onClickClose(globalState.state.formData.menu.type.version,e) } style ={{ marginLeft: "auto" }}>
              <CloseCommand />
            </div>
          </div>
          <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              Number : 
            </div>
            <div style ={{ marginTop: "4px", marginRight: "5px" }}>
              <input className="textBox" style ={{ width: "100px", textAlign: "center" }}
                onMouseLeave={() => changeMode(false)}
                onMouseDown={() => changeMode(true)}
                onChange = {(e) => fireEventByMenuAndSetValue(e, globalState.state.formData.menu.type.version,globalState.state.formData.actions.event.type.onChange) }
               value = {position.version.item.value}></input>
            </div>
            <div style ={{ marginLeft: "5px" }}>
              <ValidationCommand onClick ={(e) => onClickValid(e, globalState.state.formData.menu.type.version) } className ="hoverGreen"/>
            </div>
          </div>

          
        </div>,
         document.getElementById(VersionAddId)
      ) 
    );
  };

  const getMediaComponent = () => {
    return (
        ReactDOM.createPortal(
        <div className="dialogForm" style ={{   height: "60px", width: "270px"}}>
          
          <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              { getTitle(globalState.state.formData.menu.type.media, globalState.state.formData.menu.media.replacesValues) }
            </div>
            
            <div onClick={(e) => onClickClose(globalState.state.formData.menu.type.media,e) } style ={{ marginLeft: "auto" }}>
              <CloseCommand />
            </div>
          </div>

          <div style ={{  display: "flex" }}
            onClick={(e) => {e.stopPropagation() }}>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              Type : 
            </div>
            <DropDownListNew
              currentData={getAllowedsMedia()}
              initialValue={position.media.item.type}
              id={"MediaLists"}
              onDropDownItemClick={(itemSelected) => onSelectMediaType(itemSelected)}
              onlyLabel={false}/>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              Width :  
            </div>
            <div style ={{ marginTop: "4px", marginRight: "5px" }}>
              <input className="textBox" style ={{ width: "40px", textAlign: "center" }} 
                onMouseLeave={() => changeMode(false)}
                onMouseDown={() => changeMode(true)}
                onChange = {(e) => fireEventByMenuAndSetValue(e, globalState.state.formData.menu.type.media,globalState.state.formData.actions.event.type.onChange) }
                onKeyPress = {(e) => fireEventKeyPressByMenu(e, globalState.state.formData.menu.type.media,globalState.state.formData.actions.event.type.onkeyPress) }
                value = {position.media.item.value}></input>px
            </div>
            <div style ={{  marginLeft: "5px" }}>
              <ValidationCommand onClick ={(e) => onClickValid(e, globalState.state.formData.menu.type.media) }  className ="hoverGreen"/>
            </div>
            
          </div>
        </div>,
         document.getElementById(MediaAddId)
      ) 
    );

  };

  const getLanguageComponent = () => {
    return (
        ReactDOM.createPortal(
        <div className="dialogForm" style ={{   height: "60px", width: "200px"}}>
          
          <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              { getTitle(globalState.state.formData.menu.type.language, globalState.state.formData.menu.language.replacesValues) }
            </div>
            
            <div onClick={(e) => onClickClose(globalState.state.formData.menu.type.language,e) } style ={{ marginLeft: "auto" }}>
              <CloseCommand />
            </div>
          </div>

          <div style ={{  display: "flex" }}
            onClick={(e) => {e.stopPropagation() }}>
            <div   style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              Language : 
            </div>
            <DropDownListNew
              currentData={getAllowedsLanguages()}
              initialValue={position.language.item.value}
              id={"LanguageLists"}
              onDropDownItemClick={(itemSelected) => onSelectLanguage(itemSelected)}
              onlyLabel={false}/>
            <div style ={{  marginLeft: "5px" }}>
              <ValidationCommand onClick ={(e) => onClickValid(e, globalState.state.formData.menu.type.language) }  className ="hoverGreen"/>
            </div>
            
          </div>
        </div>,
         document.getElementById(LanguageAddId)
      ) 
    );

  };

  const getDeleteComponent = (ComponentId) => {
    return (
        ReactDOM.createPortal(
        <div className="dialogForm" style ={{   height: "60px", width: "200px" }}>
          
          <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
            <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
              { getTitle(globalState.state.formData.menu.type.form, globalState.state.formData.menu.form.replacesValues) }
            </div>
            
            <div onClick={(e) => onClickClose(globalState.state.formData.menu.type.form,e) } style ={{ marginLeft: "auto" }}>
              <CloseCommand />
            </div>
          </div>

          <div style ={{  display: "flex" }}
            onClick={(e) => {e.stopPropagation() }}>
            
            <div onClick={(e) => onClickClose(globalState.state.formData.menu.type.form,e) } >
              <input style ={{ backgroundColor: "lightGray", marginLeft: "21px", fontSize:"12px", height: "20px", padding: "0px", width: "70px", }} type="button" className="button" value="Cancel"/>
            </div>
            <div  onClick ={(e) => onClickValid(e, globalState.state.formData.menu.type.form) }>
              <input style ={{ backgroundColor: "rgb(206, 17, 38)",fontSize:"12px", height: "20px", padding: "0px", width: "70px", }} type="button" className="button" value="Delete"/>
            </div>
            
          </div>
        </div>,
         document.getElementById(ComponentId)
      ) 
    );

  };

  const getAllowedsLanguages = () => {
    switch (position.language.operation) {
      case globalState.state.formData.menu.operation.Add:{
        return globalState.state.languages.options
        .filter(option => !menuLanguages.map(lang => lang.language.id).includes(option.id) )
      }
      case globalState.state.formData.menu.operation.Update:{
        return globalState.state.languages.options
      }
      case globalState.state.formData.menu.operation.Delete:{
        return []
      }
    }
    
  };

  const getAllowedsMedia = () => {
    return globalState.state.formData.menu.media.options 
  };
  /*
        <div onClick={() => onClickDeleteLink() } style ={{  marginTop: "5px" }}>
          <SaveCommand />
        </div>
        {getSeparator()}
        <div  style ={{ marginTop: "4px", marginRight: "5px" }}>
          Sealed : 
        </div>
        <div  style ={{ marginTop: "2px", marginRight: "5px" }}>
          <CheckBox checked={position.isSealed}/> 
        </div>
        {canDelete() &&  <div id = {FormDelId} onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.form, globalState.state.formData.menu.operation.Delete) } style ={{ marginLeft: "-2px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
        {position.form.isClick && getDeleteComponent(FormDelId)}
        {getSeparator()}

  */
   
  return (
    <React.Fragment>    
      {!props.isExecutionMode && <div style ={{ display: "flex", paddingLeft: "10px"}} onClick={(e) => {e.stopPropagation() }}>
        <div  style ={{ marginTop: "4px", marginRight: "5px" }}>
          Version : 
        </div>
        <DropDownListNew
          currentData={menuVersions}
          initialValue={currentMetaData.version.value}
          id={"VersionLists"}
          onDropDownItemClick={(itemSelected) => onSelectNewMetaData(itemSelected, globalState.state.formData.menu.type.version)}
          onlyLabel={false}
        />
        {canEdit() && <div id = {VersionAddId} onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.version, globalState.state.formData.menu.operation.Add) } style ={{ marginLeft: "-10px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
        {canEdit() &&<div onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.version, globalState.state.formData.menu.operation.Update) } style ={{ marginLeft: "5px" }}>
          <MiddleEditCommand className ="hoverBlue"/>
        </div>}
        
        {position.version.isClick && getVersionComponent()}
        {getSeparator()}
        <div  style ={{ marginTop: "4px", marginRight: "5px" }}>
          Language : 
        </div>
        <DropDownListNew
          currentData={menuLanguages}
          initialValue={currentMetaData.language.value}
          id={"ActualLanguageLists"}
          onDropDownItemClick={(itemSelected) => onSelectNewMetaData(itemSelected, globalState.state.formData.menu.type.language)}
          onlyLabel={false}
        />
        {canEdit() &&<div id = {LanguageAddId} onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.language, globalState.state.formData.menu.operation.Add) } style ={{ marginLeft: "-10px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>
        }
        {canEdit() &&<div onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.language, globalState.state.formData.menu.operation.Update) } style ={{ marginLeft: "5px" }}>
          <MiddleEditCommand className ="hoverBlue"/>
        </div>
        }
        {position.language.isClick && getLanguageComponent()}
        {getSeparator()}
        <div  style ={{ marginTop: "4px", marginRight: "5px" }}>
          Media : 
        </div>
        <DropDownListNew
          currentData={menuMedias}
          initialValue={currentMetaData.media.type + " " + currentMetaData.media.value}
          id={"ActualMediaLists"}
          onDropDownItemClick={(itemSelected) => onSelectNewMetaData(itemSelected, globalState.state.formData.menu.type.media)}
          onlyLabel={false}
        />
        {canEdit() &&<div id = {MediaAddId} onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.media, globalState.state.formData.menu.operation.Add) } style ={{ marginLeft: "-10px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>
        }
        {canEdit() &&<div onClick={(e) => onClickOperation(e, globalState.state.formData.menu.type.media, globalState.state.formData.menu.operation.Update) } style ={{ marginLeft: "5px" }}>
          <MiddleEditCommand className ="hoverBlue"/>
        </div>
        }
        {position.media.isClick && getMediaComponent()}
        
        <div style ={{ marginLeft:"auto"}} >
          <input 
            onClick = {() =>loadFormData()}
            style ={{ fontSize:"12px", height: "20px", padding: "0px", width: "70px"}} 
            type="button" className="button" value="Preview"/>
        </div>
        
      </div>
      }
      <div
        className="simpleFormContainer tableForm"
        style={getStyle(formTemplate)}
        onDrop={(e) => drop(e)}
        onDragOver={(e) => dragOver(e)}
        onDragExit={(e) => position.grid.show && setPosition({...position, grid:{...position.grid, show:false}})}
        onClick={(e) => onClick(e, formTemplate)}
        id={formContainerId}
        onContextMenu={(e) => !props.isExecutionMode && onContextMenu(e) }
        
        onMouseDown={(e) => onMouseDown(e) }>
      {globalState.state.formData.metaData
        .filter((item) => item.id == parentId)[0].metaData
        .map((meta) => (
          <ToolComponent 
            key={meta.id} 
            meta={meta} 
            draggable={!props.isExecutionMode} 
            //onError={position.current.errorType.map(item =>item.id).includes(meta.id)} 
            onDragStart={(e)=>onDragStart(e,meta)}
            handleOnDrop={(updatedFormData,containerId, template, rowTemplate)=>handleOnDrop(updatedFormData,containerId, template, rowTemplate)}          
            isDragOver = {globalState.state.formData.currentDragOver.includes(meta.id)}
            updateSize ={(id, resizeWidth, resizeHeight) =>  updateSize(id, resizeWidth, resizeHeight)}
            onChange={(e, value) => changeValue(e, value, globalState.state.formData.actions.event.type.onChange)}
            onKeyPress={(e) => fireEventKeyPressByControl(e, globalState.state.formData.actions.event.type.onkeyPress)}
            //onMouseOver={(e, currentMeta) => fireEventByControlAndSetValue(e, currentMeta, globalState.state.formData.actions.event.type.onMouseOver)}
            onMouseEnter={(e, currentMeta) => fireEventByControlAndSetValue(e, currentMeta, globalState.state.formData.actions.event.type.onMouseEnter)}
            onBlur={(e, currentMeta) => fireEventByControlAndSetValue(e, currentMeta, globalState.state.formData.actions.event.type.onBlur)}
            onMouseLeave={(e, currentMeta) => fireEventByControlAndSetValue(e, currentMeta, globalState.state.formData.actions.event.type.onMouseLeave)}
            onMouseDown={(e, currentMeta) => fireEventByControlAndSetValue(e, currentMeta, globalState.state.formData.actions.event.type.onMouseDown)}
            onClick={(e, currentMeta) => fireEventByControlAndSetValue(e, currentMeta, globalState.state.formData.actions.event.type.onClick)}
          />
        ))}     
          <DropDownListNew
            currentData={contextMenus}
            id={"ContextMenu"}
            position = {position}
            isContextMenu={true}
            isExternalExpanded={position.isClickContextMenu}
            onDropDownItemClick={(itemSelected) => onRightMenuClick(itemSelected)}
            onlyLabel={false}
          />     
      </div>    
      {position.current.errorType && getErrorComponent()}
      {position.toolTip && position.toolTip.show && showToolTip()}
      {!props.isExecutionMode && position.grid.show && showGrid()}

    </React.Fragment>
  );
}
